import React, { useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { load } from '~data/actions/filters';
import { makeTagsAutocomplete } from '~data/selectors/tags';

import { Popover } from '~ui';
import Lazy from '~co/virtual/lazy';
import TagItemView from '~co/tags/item/view';
import SectionView from '~co/tags/section/view';

export default function TagsMenu({
  spaceId, //optional
  inputRef,
  selected = [],
  downshift = {},
}) {
  const dispatch = useDispatch();
  const getTagsAutocomplete = useMemo(() => makeTagsAutocomplete(), []);

  const tags = useSelector((state) =>
    getTagsAutocomplete(state, spaceId, downshift.inputValue, selected),
  );

  useEffect(() => {
    dispatch(load('global'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (parseInt(spaceId)) dispatch(load(spaceId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spaceId]);

  useEffect(() => {
    downshift.setItemCount(tags.length);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tags.length]);

  //skip sections
  useEffect(() => {
    if (
      downshift.highlightedIndex !== null &&
      tags.length &&
      tags[downshift.highlightedIndex] &&
      tags[downshift.highlightedIndex].type == 'section'
    )
      downshift.setHighlightedIndex(downshift.highlightedIndex + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downshift.highlightedIndex, downshift.inputValue]);

  const {
    isOpen,
    getMenuProps,
    getItemProps,
    highlightedIndex,
  } = downshift;

  if (!isOpen || !tags.length) return null;

  return (
    <Popover
      pin={inputRef}
      stretch={true}
      className='ui-tags-autocomplete'
      dataKey={tags.length + ':' + selected.length}
      {...getMenuProps({ refKey: 'innerRef' })}
    >
      <Lazy
        data={tags}
        keyExtractor={({ type, _id }) => (type || 'tag') + ':' + _id}
        scrollToItem={
          highlightedIndex >= 0 ? tags[highlightedIndex] : undefined
        }
      >
        {(item, index) => {
          if (!item) return null;

          if (item.type == 'section')
            return (
              <SectionView
                key={item.type + item._id}
                item={item}
              />
            );

          return (
            <TagItemView
              item={item}
              {...getItemProps({
                key: item._id,
                index,
                item,
                showIcon: false,
                active: highlightedIndex === index,
              })}
            />
          );
        }}
      </Lazy>
    </Popover>
  );
}
